import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="logo-preview"
export default class extends Controller {
  static targets = ["preview", "placeholder"]

  connect() {
  }

  updatePreview(event) {
    const file = event.target.files[0]
    console.log("File selected:", file)

    if (file) {
      const reader = new FileReader()

      reader.onload = (e) => {
        console.log("File loaded, updating preview")

        // Get the container
        const container = this.element.querySelector(".h-32.w-32")

        // Hide placeholder if it exists
        if (this.hasPlaceholderTarget) {
          this.placeholderTarget.classList.add("hidden")
        }

        // Update existing preview or create new one
        if (this.hasPreviewTarget) {
          this.previewTarget.src = e.target.result
          this.previewTarget.classList.remove("hidden")
        } else {
          // Clear container and add new image
          const img = document.createElement("img")
          img.src = e.target.result
          img.className = "h-full w-full object-contain"
          img.dataset.logoPreviewTarget = "preview"

          container.innerHTML = ""
          container.appendChild(img)
        }
      }

      reader.readAsDataURL(file)
    }
  }

  toggleRemove(event) {
    if (this.hasPreviewTarget) {
      if (event.target.checked) {
        this.previewTarget.classList.add("opacity-50")
      } else {
        this.previewTarget.classList.remove("opacity-50")
      }
    }
  }
}
